import type { GroupMember as GroupMemberModel } from '@/adapters/catalogv1.g';

export function extractGroupMember(model: GroupMemberModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    accountRef: model.account_ref ?? '',
    roleRef: model.role_ref,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupMember = ReturnType<typeof extractGroupMember>;
